module.exports = __webpack_public_path__ + "static/tactics_notebook_tablet_florball-83d2ee7f0508c05892fd9801492034b5.mp4";